<script setup>
import { useStore } from '@/store/Store.js';

defineProps({
    colors: {
        type: Object,
        default: () => ({
            txt: 'dark-blue',
            bg: 'light-blue',
        }),
    },
});

const store = useStore();
</script>
<template>
    <nav
        class="AnchorBar sticky z-50 mb-6 w-full px-6 text-sm transition-[transform,top] duration-500 will-change-[top] sm:mb-10 sm:text-base md:w-screen xl:px-12"
        :class="[
            'bg-' + colors.bg,
            'text-' + colors.txt,
            {
                'top-14 md:top-12 xl:top-28': !store.isScrolledLarge.value && !store.isScrolledSmall.value,
                'top-0 xl:top-16': store.isScrolledSmall.value,
                'top-0': store.isScrolledLarge.value,
            },
        ]"
    >
        <div
            ref="bar"
            class="AnchorBar__inner relative flex flex-wrap items-center justify-between py-2 sm:py-4 md:flex-nowrap"
        >
            <slot />
        </div>
    </nav>
</template>
